module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/landscape/deco_gray01-96ccd53d947c9be0ffe2791cb7a6a554.png";